import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import ButtonIcon from 'components/ButtonIcon/ButtonIcon';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

export const ControlsWrapStyled = styled(FlexContainer)`
  margin-top: 1rem;
  margin-bottom: 1rem;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin-top: 1rem;
    }
  `}
`;
export const ActionIconBtnStyled = styled(ButtonIcon)`
  padding: 0.563rem;
  flex: 1 1;
  border: 1px solid ${({ theme }) => theme.colors.primary.variant6};
  justify-content: center;

  &:hover {
    fill: ${({ theme }) => theme.colors.secondary.variant5};
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    border-color: ${({ theme }) => theme.colors.secondary.variant5};
  }
  ${({ theme }) => `
    ${theme.devices.tablet} {
      height: 38px;
      flex: none;
      font-size: ${theme.fontSize.lg};
    }
  `}
`;

export const ActionBtnStyled = styled(Button)`
  height: 48px;
  flex: 1 1;
  font-size: ${({ theme }) => theme.fontSize['2xl']};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.primary.variant1};
  border: 1px solid ${({ theme }) => theme.colors.primary.variant6};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};

  &:hover {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.secondary.variant5};
    border-color: ${({ theme }) => theme.colors.secondary.variant5};
  }

  ${({ theme }) => `
    ${theme.devices.tablet} {    
      width: 140px;
      height: 38px;
      flex: none;
      font-size: ${theme.fontSize.lg};
    }
  `}
`;

export const TypographyStyled = styled(Typography)`
  margin-top: 1rem;
`;

export const FlexContainerMessageStyled = styled(FlexContainer)`
  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding: 0 2.5rem 0.625rem;
    }
  `}
`;

export const TypographyTitleStyled = styled(Typography)`
  margin-bottom: 1.875rem;
`;

export const FormStyled = styled.form`
  width: 100%;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      width: 100%;
    }
  `}
`;

export const FormElementWrapStyled = styled.div`
  margin-bottom: 1.2rem;
`;

export const getPopupContentStyle = (isMobile: boolean, isDesktop: boolean) => ({
  width: '100%',
  height: isMobile ? '100%' : 'auto',
  minWidth: isMobile ? 'auto' : '600px',
  maxWidth: '1100px',
  minHeight: isDesktop ? '540px' : '0',
  maxHeight: isMobile ? '100%' : '95vh',
  padding: isMobile ? '0.625rem 1.25rem 1.375rem' : '0.625rem 1.875rem 1.375rem',
  overflow: 'auto',
});

export const HeaderStyled = styled.header`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 0.625rem;
  flex-direction: column-reverse;
  gap: 0.5rem;

  ${({ theme }) => `
    ${theme.devices.smallDesktop} {
     flex-direction: row;
     margin-bottom: 1.25rem;
      
    }
  `}
`;

export const HeaderInfoStyled = styled.div`
  display: flex;
  flex: 1 1;
  gap: 0.5rem;
  ${({ theme }) => `
    ${theme.devices.smallDesktop} {
     gap: 1rem;
    }
  `}
`;

export const HeaderControlsStyled = styled.div`
  display: flex;
  margin-left: 1rem;
  align-self: end;
  ${({ theme }) => `
    ${theme.devices.smallDesktop} {
      align-self: baseline;
  `}
`;

export const CopyIconBtnStyled = styled(ButtonIcon)`
  margin-left: 0.375rem;
`;

export const CloseIconBtnStyled = styled(ButtonIcon)`
  margin-left: 0.25rem;
`;

export const ContentStyled = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      flex-direction: row;
    }
  `}
`;

export const ContentInfoStyled = styled.div`
  display: flex;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      flex-direction: column;
      margin-right: 1.25rem;
    }

    ${theme.devices.smallDesktop} {
      margin-right: 3.75rem;
    }
  `}
`;

export const ContentInfoItemStyled = styled.div`
  &:not(:last-child) {
    margin-bottom: 1.25rem;
    margin-right: 1.5rem;
  }

  ${({ theme }) => `
    ${theme.devices.tablet} {
      &:not(:last-child) {
        margin-right: 0;
      }
    }
  `}
`;

export const ContentInfoTypographyStyled = styled(Typography)`
  margin-bottom: 0.125rem;
`;

export const MessagesWrapStyled = styled.div`
  flex: 1;
`;

export const FlexStyled = styled(FlexContainer)`
  height: 100%;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      height: 494px;
    }
  `}
`;

export const FieldLabelStyled = styled.label`
  display: block;
  white-space: nowrap;
  margin-bottom: 0.25rem;
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.primary.variant8};
`;

export const ScheduleHeaderLabelStyled = styled.label`
  display: block;
  white-space: nowrap;
  font-size: ${({ theme }) => theme.fontSize.xl};
  color: ${({ theme }) => theme.colors.primary.variant9};
`;

export const FlexContainerScheduleStyled = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${FormElementWrapStyled} {
    width: 100%;
  }
  ${ScheduleHeaderLabelStyled} {
    align-self: start;
    margin-bottom: -13px;
  }
`;

export const ScheduleInfoWrapStyled = styled(FlexContainer)`
  margin-bottom: 1.2rem;
  width: 100%;
  ${TypographyStyled} {
    margin-right: 10px;
  }
`;
